// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PaymentMethodIcon_img__ZaYpF {
  display: block;
  border: .0625rem solid var(--p-color-border-secondary,rgba(235, 235, 235, 1));
  border-radius: 3px;
  height: 1.5rem;
  min-width: 2.375rem;
}
`, "",{"version":3,"sources":["webpack://./src/payment-method-widget/PaymentMethodIcon.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,6EAA6E;EAC7E,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB","sourcesContent":[".img {\n  display: block;\n  border: .0625rem solid var(--p-color-border-secondary,rgba(235, 235, 235, 1));\n  border-radius: 3px;\n  height: 1.5rem;\n  min-width: 2.375rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"img": `PaymentMethodIcon_img__ZaYpF`
};
export default ___CSS_LOADER_EXPORT___;
